import React from 'react';

function TransparentChecked () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      fill="none"
      viewBox="0 0 20 14"
    >
      <path
        fill="#4FADA6"
        fillRule="evenodd"
        d="M19.082.699a1.297 1.297 0 00-1.834 0l-9.844 9.844L2.75 5.889A1.296 1.296 0 00.917 7.723l5.664 5.665a1.164 1.164 0 001.645 0L19.082 2.533a1.297 1.297 0 000-1.834z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default TransparentChecked;
